import styled, { css } from 'styled-components'
// components
import { Paper as PaperOrigin } from 'components/UI'
// themes
import { colors } from 'themes/index'
// constants
import { SIDEBAR_NAVIGATION_WIDTH } from 'constants/layout'

export const NavigationWrapper = styled.div`
  &:first-child {
    margin-top: 8px;
  }

  a {
    cursor: pointer;
    color: inherit;
    text-decoration: none;

    &:hover,
    &:active,
    &:focus,
    &:visited {
      text-decoration: none;
      color: inherit;
    }

    &:hover {
      color: ${colors.purple300};
    }
  }
`

export const NavigationCell = styled.div<{ $isActive: boolean }>`
  align-items: center;
  display: flex;
  font-size: 14px;
  justify-content: flex-start;
  margin: 0 0 0 5px;
  padding: 10px;

  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: ${colors.purple270};
      border-bottom-right-radius: 20px;
      border-top-right-radius: 20px;
      color: ${colors.black};
      font-weight: 500;
    `}
  > :first-child {
    margin: 0 15px 0 5px;
  }

  &:hover {
    svg {
      ${({ $isActive }) => !$isActive && `fill: ${colors.purple300}`};
    }
  }
`

export const FixedSidebar = styled.div`
  height: 100%;
  position: fixed;
  width: ${SIDEBAR_NAVIGATION_WIDTH}px;

  transition: ${({ theme }: any) =>
    theme.transitions.create(['left'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })};
`

export const Paper = styled((props) => <PaperOrigin {...props} />)`
  && {
    background: transparent;
    height: 100%;
  }
`
